export const ticketsReducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_TICKETS':
            return{
                ...state,
                tickets: action.payload.tickets,
                total: action.payload.total,
                loading: action.loading ?? false
            }
        case 'PATCH_TICKET':
            return {
                ...state,
                tickets: state.tickets.map(t =>
                    t.id === action.payload.id ? { ...t, ...action.payload.data } : t
                ),
            }
        case 'REMOVE_TICKET':
            return {
                ...state,
                tickets: state.tickets.filter(t => t.id !== action.payload.id),
                total: (state.total ?? 1) - 1,
            }
        default:
            return{
                ...state
            }
    }
}

export const unseenTicketsReducer = (state = { ids: [] }, action) => {
    switch (action.type) {
        case 'GET_UNSEEN_TICKETS':
            return {
                ...state,
                ids: Array.isArray(action?.payload?.ids) ? action.payload.ids : state.ids,
                loading: action.loading ?? false
            }
        case 'MARK_SEEN_TICKETS':
            return {
                ...state,
                ids: Array.isArray(action?.payload?.ids)
                    ? state.ids.filter(id => !action.payload.ids.includes(id))
                    : state.ids,
                loading: false
            }
        default:
            return{
                ...state
            }
    }
}

export const detailsTicket = (state = [], action) =>{
    switch (action.type) {
        case 'GET_DETAIL_TICKET':
            return{
                ...state,
                details: action.payload,
                loading: action.loading ?? false
            }
        case 'CLEAR':
            return{
                ...state,
                details: undefined,
                loading: action.loading ?? false
            }
        default:
            return {
                ...state,
            }
    }
}

export const newTickets = (state = [], action) => {
    switch (action.type) {
        case 'GET_NOTIFICATION_TICKET':
            return{
                ...state,
                new_tickets: action.payload,
                loading: action.loading ?? false
            }
        default:
            return{
                ...state
            };
    }
}

export const newComments = (state = [], action) => {
    switch (action.type) {
        case 'GET_COMMENTS':
            return{
                ...state,
                comments: action.payload,
                loading: action.loading ?? false
            }
        default:
            return {
                ...state
            };
    }
}
